<div class="h-full flex flex-col justify-start items-center overflow-hidden space-y-2">

    <div class="h-full flex-1 flex-col items-center justify-center w-full overflow-hidden">
        @if (briefQuestions()) {
        <div class="w-full grid grid-cols-3 gap-x-4 h-full overflow-hidden">

            <article
                class="col-span-1 h-full overflow-hidden flex flex-col primary-card-container divide-y divide-gray-200 dark:divide-zinc-700">
                <div class="shrink-0 flex flex-row items-center justify-between flex-nowrap pb-2">
                    <div class="flex items-center flex-row gap-x-2">
                        <div
                            class="shrink-0 size-8 rounded-full bg-gray-50 dark:bg-zinc-800 flex items-center justify-center text-primary">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="size-6">
                                <path
                                    d="M10.5 22H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.706.706l3.588 3.588A2.4 2.4 0 0 1 20 8v6" />
                                <path d="M14 2v5a1 1 0 0 0 1 1h5" />
                                <path d="m14 20 2 2 4-4" />
                            </svg>
                        </div>
                        <div class="">
                            <h3 class="text-sm font-semibold text-primary">Brief Details</h3>
                        </div>
                    </div>
                    <div class="flex shrink-0 gap-x-2 text-transparent">
                        RHS
                    </div>
                </div>
                <div class="flex-1 flex flex-col overflow-y-auto scrollbar-transparent">


                    <dl class="divide-y divide-white/5">
                        <div class="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                            <dt class="text-sm font-medium text-gray-100">Brief ID</dt>
                            <dd class="mt-1 text-sm/6 text-gray-300 sm:col-span-2 sm:mt-0">{{ briefQuestions()!.briefId
                                }}</dd>
                        </div>
                        <div class="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                            <dt class="text-sm font-medium text-gray-100">Brief Name</dt>
                            <dd class="mt-1 text-sm/6 text-gray-300 sm:col-span-2 sm:mt-0">{{
                                briefQuestions()!.briefName }}</dd>
                        </div>
                        <div class="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                            <dt class="text-sm font-medium text-gray-100">Brand Name</dt>
                            <dd class="mt-1 text-sm/6 text-gray-300 sm:col-span-2 sm:mt-0">{{
                                briefQuestions()!.organizationId }}</dd>
                        </div>
                        <div class="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                            <dt class="text-sm font-medium text-gray-100">What are "Questions"?</dt>
                            <dd class="mt-1 text-sm/6 text-gray-300 sm:col-span-2 sm:mt-0">Your Screening Brief has been
                                analysed by our AI to
                                create a set of tests. The computer asks each of these questions to the content of the
                                post. If a "do" question is asked, the
                                content must exhibit an example of what the question is asking to pass the test. If a
                                "don't" question is asked,
                                the content must not exhibit an example of what the question is asking to pass the test.
                            </dd>
                        </div>

                    </dl>



                </div>
            </article>

            <article
                class="col-span-2 h-full overflow-hidden flex flex-col primary-card-container divide-y divide-gray-200 dark:divide-zinc-700">
                <div class="flex flex-row items-center justify-between flex-nowrap pb-2">
                    <div class="flex items-center flex-row gap-x-2">
                        <div
                            class="shrink-0 size-8 rounded-full bg-gray-50 dark:bg-zinc-800 flex items-center justify-center text-primary">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="size-6">
                                <path d="M13 5h8" />
                                <path d="M13 12h8" />
                                <path d="M13 19h8" />
                                <path d="m3 17 2 2 4-4" />
                                <path d="m3 7 2 2 4-4" />
                            </svg>
                        </div>
                        <div class="">
                            <h3 class="text-sm font-semibold text-primary">Brief Questions</h3>
                        </div>
                    </div>
                    <div class="flex shrink-0 gap-x-2">
                        <p class="text-sm text-secondary">
                            <span class="font-semibold text-primary">{{ briefQuestions()!.questions.length }}</span>
                            questions</p>
                    </div>
                </div>
                <div class="flex-1 flex flex-col overflow-hidden">
                    <ul role="list" class="h-full flex flex-col space-y-2 py-4 overflow-y-auto scrollbar-transparent">
                        @for (question of briefQuestions()!.questions; track question.id) {
                        <app-noodle-question-basic [question]="question"></app-noodle-question-basic>
                        }
                    </ul>


                </div>
            </article>

        </div>
        } @else {
        <div class="flex flex-col items-center justify-center w-full overflow-hidden">
            <p class="text-sm/6 text-secondary">Loading brief questions...</p>
        </div>
        }
    </div>
</div>